'use client';

/** Left pane of the skills picker: the selectable result list. */

import React from 'react';
import type { MeridianSkillPickerItem } from './types';

export interface SkillListProps {
  skills: readonly MeridianSkillPickerItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  loading: boolean;
  total: number;
}

export function SkillList({ skills, selectedId, onSelect, loading, total }: SkillListProps) {
  return (
    <div className="border border-border rounded-md overflow-y-auto max-h-[22rem]">
      {loading ? (
        <p className="p-3 text-sm text-muted-foreground">Loading skills…</p>
      ) : skills.length === 0 ? (
        <p className="p-3 text-sm text-muted-foreground">No skills match.</p>
      ) : (
        <ul className="divide-y divide-border" role="listbox" aria-label="Skills">
          {skills.map((skill) => {
            const active = skill.id === selectedId;
            return (
              <li key={skill.id}>
                <button
                  type="button"
                  role="option"
                  aria-selected={active}
                  onClick={() => onSelect(skill.id)}
                  className={[
                    'w-full text-left px-3 py-2.5 transition-colors',
                    active ? 'bg-primary/10' : 'hover:bg-muted',
                  ].join(' ')}
                >
                  <div className="text-sm font-medium text-foreground truncate">{skill.id}</div>
                  <div className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
                    {skill.description}
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
      {!loading && total > skills.length && (
        <p className="px-3 py-2 text-xs text-muted-foreground border-t border-border">
          Showing {skills.length} of {total}
        </p>
      )}
    </div>
  );
}
